import { render, staticRenderFns } from "./EvalDocenteAdmCreate.vue?vue&type=template&id=a56f5a52"
import script from "./EvalDocenteAdmCreate.vue?vue&type=script&lang=js"
export * from "./EvalDocenteAdmCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports